import React from "react";

const SvgUnderLineIcon = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width || "1em"}
      height={width || "1em"}
      viewBox="0 0 108 80"
      style={style}
      fill="currentColor"
    >
      <defs />
      <defs>
        <clipPath id="clip-underline">
          <path d="M0 0h108v80H0z" />
        </clipPath>
      </defs>
      <g id="underline" clipPath="url(#clip-underline)">
        <g id="font">
          <g
            id="Group_19853"
            data-name="Group 19853"
            transform="translate(64.756 28.576)"
          >
            <g id="Group_19852" data-name="Group 19852">
              <path
                id="Path_38531"
                d="M336.476 202.769v2.949a18.7 18.7 0 100 29.165v2.949h7.013v-35.063zm-11.688 29.219a11.688 11.688 0 1111.688-11.688 11.7 11.7 0 01-11.688 11.688z"
                data-name="Path 38531"
                transform="translate(-306.088 -201.6)"
              />
            </g>
          </g>
          <g
            id="Group_19855"
            data-name="Group 19855"
            transform="translate(0 72.988)"
          >
            <g id="Group_19854" data-name="Group 19854">
              <path
                id="Rectangle_11801"
                d="M0 0h108v7.013H0z"
                data-name="Rectangle 11801"
              />
            </g>
          </g>
          <g
            id="Group_19857"
            data-name="Group 19857"
            transform="translate(6.548)"
          >
            <g id="Group_19856" data-name="Group 19856">
              <path
                id="Path_38532"
                d="M59.695 65.534L31.18 130.341h7.661l9.771-22.206h22.166l9.771 22.206h7.661zm-8 35.588l8-18.175 8 18.175z"
                data-name="Path 38532"
                transform="translate(-31.18 -65.534)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SvgUnderLineIcon;
